import { ComponentFactoryResolver, Injectable } from '@angular/core';

@Injectable()
export class ModalService {
  rootViewContainer: any;

  constructor(private resolver: ComponentFactoryResolver) {}

  public setRootViewContainerRef(viewContainerRef) {
    this.rootViewContainer = viewContainerRef;
  }

  public addDynamicComponent(customComponent: any) {
    const factory = this.resolver.resolveComponentFactory(customComponent);
    const component = factory.create(this.rootViewContainer.parentInjector);

    this.rootViewContainer.insert(component.hostView);
  }
}
